import React from "react";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../components/bootstrap/Modal";
import Button from "../../../../components/bootstrap/Button";


type DeleteConfirmationModalProps = {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onDelete: (id: string) => void;
    delId: string;
    setDelId: React.Dispatch<React.SetStateAction<string>>;
    themeStatus: "light" | "dark";
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    isOpen,
    setIsOpen,
    onDelete,
    delId,
    setDelId,
    themeStatus,
}) => {
    return (
        <Modal isCentered setIsOpen={setIsOpen} isOpen={isOpen}>
            <ModalHeader>
                <ModalTitle id="delete-template">Confirm Deletion</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <p>Are you sure you want to delete this scheduled interview?</p>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="bg-info-subtle"
                    style={{ borderRadius: "0.5rem" }}
                    onClick={() => {
                        setDelId("");
                        setIsOpen(false);
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                    }}
                >
                    Cancel
                </Button>
                <Button
                    className="bg-danger bg-gradient"
                    onClick={() => onDelete(delId)}
                    style={{
                        borderRadius: "0.5rem",
                        background:
                            themeStatus === "light"
                                ? "linear-gradient(45deg, #ff8e53, #ff6b6b)"
                                : "linear-gradient(45deg, #ff6b6b, #ff8e53)",
                        border: "none",
                        color: "#fff",
                        fontWeight: "600",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        boxShadow: "0 4px 12px rgba(255,107,107,0.3)",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                            "0 6px 16px rgba(255,107,107,0.4)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(255,107,107,0.3)";
                    }}
                >
                    Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteConfirmationModal;
